/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
import useConnectionContext from '@hooks/useConnectionContext';
import useProductsContext from '@hooks/useProductsContext';
import Skeleton from 'react-loading-skeleton';

import raProductImg from '@assets/ra-product.png';
import raImage from '@assets/Return assurance.png';
import odImage from '@assets/Delivery guarantee.png';
import irImage from '@assets/Instand refund.png';
import bpImage from '@assets/Buyer protection.png';
import { useNavigate } from 'react-router-dom';
import { PRODUCT_NAME } from '@/constants';
import { popupCenter } from '../../utils';

import 'react-loading-skeleton/dist/skeleton.css';
import classes from './ProductGallery.module.css';

function ProductSkeleton() {
  return (
    <div className={classes.product}>
      <Skeleton containerClassName={classes.product_img} style={{ height: '100%', width: '100%' }} />
      <div style={{ width: '15px', height: '15px' }} />
      <div className={classes.product_info}>
        <Skeleton containerClassName={classes.product_title} style={{ height: '100%', width: '100%' }} />
        <Skeleton count={2} containerClassName={classes.product_brief} />
        <Skeleton containerClassName={classes.product_pending} style={{ height: '100%', width: '100%' }} />
      </div>
    </div>
  );
}

function ProductCard(props) {
  const { store } = useConnectionContext();
  const navigate = useNavigate();
  const {
    title, brief, status, authorized, isShowEnable,
  } = props || {};
  // const images = [raImage, null, null, null, bpImage, irImage, null, odImage, bpImage, raImage, raImage, raImage];
  const images = {
    [PRODUCT_NAME.RETURN_ASSURANCE]: raImage,
    [PRODUCT_NAME.BUYER_PROTECTION]: bpImage,
    [PRODUCT_NAME.INSTANT_REFUND]: irImage,
    [PRODUCT_NAME.DELIVERY_GUARANTEE]: odImage,
    [PRODUCT_NAME.SHIPPING_PROTECTION]: bpImage,
    [PRODUCT_NAME.GREEN_SHIPPING_PROTECTION]: bpImage,
    [PRODUCT_NAME.INSTANT_REFUND]: irImage,
  };

  const clickHandler = () => {
    if (authorized && title === PRODUCT_NAME.RETURN_ASSURANCE) {
      navigate('/ra/application/intro');
      return;
    }
    if (authorized) {
      window.open('https://ntcchgwtg0g.typeform.com/to/EdBu9IDK');
    } else {
      popupCenter({
        url: `https://${process.env.SHOPIFY_APP_INSALLATION_URI}?shop=${store.info}`, title: '', w: 800, h: 600,
      });
    }
  };
  return (
    <div className={classes.product}>
      <img className={classes.product_img} src={images[title] || raProductImg} alt={title} />
      <div style={{ width: '15px', height: '15px' }} />
      <div className={classes.product_info}>
        <div className={classes.product_title}>{title}</div>
        <div className={classes.product_brief}>{brief}</div>
        {
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          status === 'live'
            ? (!isShowEnable
              ? <div className={`${classes.product_apply} ${classes.product_apply_disable}`}>Enable &#8594;</div>
              : <div className={classes.product_apply} onClick={clickHandler}>Enable &#8594;</div>
            )
            : <div className={classes.product_pending}>Coming soon</div>
        }
      </div>
    </div>
  );
}

function Gallery() {
  const {
    productsGallery, productsInvolved, galleryLoading, involvedLoading,
  } = useProductsContext();

  if (galleryLoading || involvedLoading) {
    return new Array(4).fill('empty').map((item, index) => <ProductSkeleton key={index} />);
  }

  return productsGallery.map((product) => {
    const { insuranceName, authorized } = product;
    // let isActive = false;
    let isShowEnable = true;
    productsInvolved.forEach((item) => {
      const { name, status } = item || {};
      // if (name === insuranceName && status === 'active') {
      //   isActive = true;
      // }
      // 指定状态下，不能点击enable
      if (name === insuranceName && ['pending', 'inactive', 'active'].includes(status)) {
        isShowEnable = false;
      }
    });
    return <ProductCard key={product.insuranceName} authorized={authorized} title={product.insuranceName} brief={product.insuranceDescription} status={product.status} id={product.insuranceId} isShowEnable={isShowEnable} />;
  });
}

export default Gallery;
